import { useEffect, useRef, useState, type JSX } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import CarouselSection from './components/CarouselSection';
import CommentsSection from './components/CommentsSection';
import IndexSection from './components/IndexSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import MediaSection from './components/MediaSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import FaqSection from './components/FaqSection';
import Footer from './components/Footer';

function AnimatedSection({ children }: { children: JSX.Element }) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.08 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`transition-all duration-700 ease-out ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      {children}
    </div>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <AnimatedSection><Hero /></AnimatedSection>
        <AnimatedSection><CarouselSection /></AnimatedSection>
        <AnimatedSection><CommentsSection /></AnimatedSection>
        <AnimatedSection><IndexSection /></AnimatedSection>
        <AnimatedSection><UpdatesSection /></AnimatedSection>
        <AnimatedSection><AppSection /></AnimatedSection>
        <AnimatedSection><FeaturesSection /></AnimatedSection>
        <AnimatedSection><RankingSection /></AnimatedSection>
        <AnimatedSection><TopicsSection /></AnimatedSection>
        <AnimatedSection><MediaSection /></AnimatedSection>
        <AnimatedSection><AboutSection /></AnimatedSection>
        <AnimatedSection><CardsSection /></AnimatedSection>
        <AnimatedSection><ContactSection /></AnimatedSection>
        <AnimatedSection><FaqSection /></AnimatedSection>
      </main>
      <AnimatedSection><Footer /></AnimatedSection>
    </div>
  );
}